module.exports = __webpack_public_path__ + "static/media/icon-20-time.50b96aa8.svg";